import {RoutingLogMonthResponse, RoutingLogResponse} from "../response/routing-log-response";
import {RoutingLogMonthly, RoutingLogSummary} from "../../types/routing-service/routing-log-summary";
import {getCurrentFormattedTime} from "../../utils/date/date-format";

export const mapToRoutingMonthly = (response: RoutingLogMonthResponse): RoutingLogMonthly => {
    return {
        last: mapToRoutingSummary(response.lastMonthSummary),
        current: mapToRoutingSummary(response.currentMonthSummary),
        formattedUpdateTime: getCurrentFormattedTime()
    };
};

const mapToRoutingSummary = (response: RoutingLogResponse): RoutingLogSummary => {
    return {
        estimatedCharge: response.estimatedCharge,
        numRequests: response.numRequests,
    }
}
